import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectWorksheet } from 'services/worksheet/selectors';
import get from 'lodash.get';
import moment from 'moment';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { getSprayEventApplicationTypeDisplay } from 'services/sprayEvents/utils';
import { getWorksheetHeaderEntities } from 'services/worksheet/utils';
import { OwnProps } from './index';

const selectPageIndex = (
    state: AppState,
    props: OwnProps
): WorksheetPageIndex => props.pageIndex;

const selectSprayWorksheetDate = createDeepEqualSelector(
    selectWorksheet,
    (sprayWorksheetState) => get(sprayWorksheetState, 'date', '')
);

const selectFormattedSprayWorksheetDate = createDeepEqualSelector(
    selectSprayWorksheetDate,
    (sprayWorksheetDateState) => {
        if (sprayWorksheetDateState) {
            return moment(sprayWorksheetDateState, 'YYYY-MM-DD').format(
                'ddd, MMM DD, YYYY'
            );
        }

        return '';
    }
);

const makeSelectFormattedSprayWorksheetDate =
    (): typeof selectFormattedSprayWorksheetDate =>
        selectFormattedSprayWorksheetDate;

const selectSprayWorksheetUser = createDeepEqualSelector(
    selectWorksheet,
    (sprayWorksheetState) => get(sprayWorksheetState, 'user')
);

const selectSprayWorksheetUserEmail = createDeepEqualSelector(
    selectSprayWorksheetUser,
    (sprayWorksheetUserState) => get(sprayWorksheetUserState, 'email', '')
);

const makeSelectSprayWorksheetUserEmail =
    (): typeof selectSprayWorksheetUserEmail => selectSprayWorksheetUserEmail;

const selectSprayWorksheetOperator = createDeepEqualSelector(
    selectWorksheet,
    (sprayWorksheetState) => get(sprayWorksheetState, 'user')
);

const selectSprayWorksheetOperatorFullName = createDeepEqualSelector(
    selectSprayWorksheetOperator,
    (worksheetOperator) =>
        worksheetOperator &&
        [worksheetOperator.firstName, worksheetOperator.lastName].join(' ')
);

const makeSelectSprayWorksheetOperatorFullName =
    (): typeof selectSprayWorksheetOperatorFullName =>
        selectSprayWorksheetOperatorFullName;

const selectSprayWorksheetEntities = createDeepEqualSelector(
    selectWorksheet,
    selectPageIndex,
    (sprayWorksheetState, pageIndex) => {
        const entitySummaries = get(sprayWorksheetState, [
            'pages',
            pageIndex,
            'entitySummaries'
        ]);

        return getWorksheetHeaderEntities(entitySummaries);
    }
);

const makeSelectSprayWorksheetEntities =
    (): typeof selectSprayWorksheetEntities => selectSprayWorksheetEntities;

const selectSprayWorksheetEarliestHarvestDate = createDeepEqualSelector(
    selectWorksheet,
    selectPageIndex,
    (sprayWorksheetState, pageIndex) => {
        const earliestHarvestDate = get(
            sprayWorksheetState,
            ['pages', pageIndex, 'earliestHarvestDate'],
            ''
        );

        if (earliestHarvestDate) {
            return moment(earliestHarvestDate, 'YYYY-MM-DD').format(
                'ddd, MMM DD, YYYY'
            );
        }

        return '';
    }
);

const makeSelectSprayWorksheetEarliestHarvestDate =
    (): typeof selectSprayWorksheetEarliestHarvestDate =>
        selectSprayWorksheetEarliestHarvestDate;

export {
    selectSprayWorksheetDate,
    selectSprayWorksheetUser,
    selectSprayWorksheetUserEmail,
    makeSelectSprayWorksheetUserEmail,
    makeSelectFormattedSprayWorksheetDate,
    makeSelectSprayWorksheetEntities,
    makeSelectSprayWorksheetEarliestHarvestDate,
    makeSelectSprayWorksheetOperatorFullName
};
